import GLOBALS from '../utils/Constants';
import UserService from './users-service';

class ToursService{
  	static sharedInstance = ToursService.sharedInstance ? this.sharedInstance : new ToursService();

    constructor(){
    	//initialize
	    this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    getUpdatedCrendetials(){
    	this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    async getFacilityLocationsByFacilityId(facility_id){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "facility_id": facility_id
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_FACILITY_LOCATIONS+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	    });
	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("error");
	        console.error(error);
	    }
	}

	async getFacilityLocationById(facilityLocationId){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "id": facilityLocationId
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_FACILITY_LOCATION+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	    });
	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("error");
	        console.error(error);
	    }
	}

	async saveSchedules(ids, schedules){

        this.getUpdatedCrendetials();

	  	const finalParams = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "ids": JSON.stringify(ids), //array of ids
	        "schedules": JSON.stringify(schedules) //json data of schedules
	    }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);
        console.log("saveSchedules params", finalParams);



        const response = await fetch(GLOBALS.SAVE_LOCATION_SCHEDULES, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("saveSchedules error:", error);
        }
    }

    async savePostOrders(ids, post_orders){

        this.getUpdatedCrendetials();

	  	const finalParams = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "ids": JSON.stringify(ids), //array of ids
	        "post_orders":  JSON.stringify(post_orders)  //json data of schedules
	    }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);


        const response = await fetch(GLOBALS.SAVE_LOCATION_POST_ORDERS, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("savePostOrders error:", error);
        }
    }
}

export default ToursService;